import styled from 'styled-components';

import { Button } from '@main/pc-core-components/src/Button';

/**
 * Confirm components visibility props
 */
export interface VisibilityProps {
  /** Whether the message should be visible or not, so that the Yes/No buttons can align with Cancel */
  visible: boolean;
}

/**
 * Confirm text wrapper
 */
export const ConfirmText = styled.p<VisibilityProps>`
  font-size: 12px;
  transition: all 0.3s;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 8px;
`;

/**
 * Error text wrapper
 */
export const ErrorWrapper = styled.p`
  font-size: 12px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.error};
`;

/**
 * Styled button
 */
export const StyledButton = styled(Button)`
  padding: 10px 16px;
  margin-right: 12px;

  &:last-child {
    margin-right: 0;
  }
`;
